import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="fullscreen-spinner">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
